import $ from 'jquery'

import '../../../scss/app/appointment.scss'

const $root = $('#appointment-slots')
const $slideOuterContainer = $root.find('.slide-container-outer')

function getSlideContainer() {
  return $root.find('.slide-container')
}

function setupLocationDropdown() {
  $root.find('.location-dropdown').on('change', (ev) => {
    window.location = $(ev.currentTarget).val()
  })
}

function setupSlides() {
  const $leftArrow = $root.find('.left-arrow')
  const $rightArrow = $root.find('.right-arrow')
  let slideIndex = 0

  const updateSlider = () => {
    if (!slideIndex) {
      $leftArrow.removeClass('visible')
      $rightArrow.addClass('visible')
    } else {
      $leftArrow.addClass('visible')
      $rightArrow.removeClass('visible')
    }

    const sliderWidth = $slideOuterContainer.width()
    getSlideContainer().css('transform', `translateX(${slideIndex * sliderWidth * -1}px)`)
  }

  $leftArrow.on('click', () => {
    slideIndex -= 1
    updateSlider()
  })

  $rightArrow.on('click', () => {
    slideIndex += 1
    updateSlider()
  })

  updateSlider()
  $(window).resize(updateSlider)
}

setupLocationDropdown()
setupSlides()
